const data = ['utahskateboarding', 'utahskater'];

export default data;
